import React, { Component } from 'react'
import css from './styles.scss'
import { connect } from 'react-redux'
import { createVariable, editVariable, editVariables, stopEditingVariables, initNewVariable, changeVariableOrder, changesMade } from '../../actions/actions'
import { generateVariableKey } from '../../utils'
import MacroLink from '../MacroLink'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'

export class VarList extends Component {
  constructor () {
    super()
    this.state = {
      toggle: false
    }
  }

  componentDidMount () {
    document.addEventListener('click', this.closeDropDown)
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.closeDropDown)
  }

  closeDropDown = evt => {
    const { toggle } = this.state
    const notDropDown = evt.target.getAttribute('id') !== 'varListToggle'
    if (toggle && notDropDown) {
      this.handleVarList()
    }
  }

  newVariable = () => {
    this.props.dispatch(initNewVariable())
  }

  handleOnDragEnd = result => {
    try {
      const { destination: { index: newIdx }, source: { index: oldIdx }, draggableId } = result
      this.props.dispatch(changeVariableOrder(draggableId, oldIdx, newIdx))
    } catch (err) {

    }
  }

  toggleVariableEdit = () => {
    if (this.props.variables.editMode) {
      this.props.dispatch(stopEditingVariables())
    } else {
      this.props.dispatch(editVariables())
    }
  }

  handleVarList = () => {
    this.setState(prevState => ({ toggle: !prevState.toggle }))
  }

  handleCreateVariable = evt => {
    const varKey = generateVariableKey()
    this.props.dispatch(createVariable(varKey, 'unnamed', evt.target.getAttribute(['data-macro'])))
    this.props.dispatch(editVariable(varKey))
    this.props.onHandleModal(null, true)
  }

  render () {
    const { item: { variables: vars, variableOrder }, variables: { editing }, app: { primaryColor, isSafari }, modal } = this.props
    const { toggle } = this.state
    if (isSafari) {
      return (
        <div className={css.VarList}>
          <p className={css.noSafari}>
            The variable editor is not available in the Safari browser for OSX. Please use Chrome or Firefox.
          </p>
        </div>
      )
    }
    const order = variableOrder || []
    const newVariableForm = null

    const variableList = order.map((key, i) => {
      const variable = vars[key]
      const macroProps = {
        varName: key
      }
      return (
        <Draggable draggableId={key} index={i} key={`${i}_chunk`}>
          {(provided, snapshot) => {
            provided.draggableProps.style = { ...provided.draggableProps.style, background: key === editing ? primaryColor : null }
            return (
              <li
                key={`${i}_chunk`}
                ref={provided.innerRef}
                className={`${css.li} ${key === editing ? css.currentTab : null}`}
                onClick={() => this.props.dispatch(editVariable(key))}
                {...provided.draggableProps}
              >
                <MacroLink {...macroProps} type={variable.macro} dragHandleProps={provided.dragHandleProps} modal={modal} changesMade={changesMade} isDraggable inListing />
              </li>
            )
          }}
        </Draggable>)
    })
    return (
      <DragDropContext
        onDragStart={this.handleOnDragStart}
        onDragUpdate={this.handleOnDragUpdate}
        onDragEnd={this.handleOnDragEnd}
      >
        <div className={css.VarList}>
          <Droppable droppableId='variables' type='VARIABLE'>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                <div className={css.flexy}>
                  <button
                    className={`${css.btn} ${toggle ? css.currentTab : null}`}
                    style={{ background: toggle ? primaryColor : null }}
                    onClick={this.handleVarList}
                    id='varListToggle'
                  >
                  Variables <i className={`${css.btnAdd}`}>{toggle ? '-' : '+'}</i>
                  </button>
                  <div className={css.varList} onClick={this.handleCreateVariable} style={{ visibility: toggle ? 'visible' : 'hidden' }}>
                    <button className={css.btn} data-macro='randomNumber'>Random Number</button>
                    <button className={css.btn} data-macro='choiceFromDataSource'>Random Row</button>
                    <button className={css.btn} data-macro='choiceFromDataSourceColumn'>Random Cell</button>
                    <button className={css.btn} data-macro='choiceFromDataSourceColumnName'>Random Column Name</button>
                    <button className={css.btn} data-macro='formula'>Formula</button>
                    <button className={css.btn} data-macro='operator'>Operator</button>
                    <button className={css.btn} data-macro='javascript'>Code</button>
                    <button className={css.btn} data-macro='math'>Math Expression</button>
                  </div>
                </div>
                <ul className={css.ul}>
                  {variableList}
                </ul>
                {newVariableForm}
              </div>
            )}
          </Droppable>
        </div>
      </DragDropContext>
    )
  }
}

const mapStateToProps = state => {
  const { app, variables, item } = state
  return {
    app,
    variables,
    item
  }
}

export default connect(mapStateToProps)(VarList)



// WEBPACK FOOTER //
// /app/js/components/VarList/index.js